import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { RankingBody } from "./RankingBody";
import { RankingHeader } from "./RankingHeader";
// todo: disbale tabs
export var TabRanking = function (_a) {
    return (React.createElement("div", { className: "w100 h100 flex flex--stacked flex__full ranking-menu " + IdStyles.TextNormal },
        React.createElement(RankingHeader, null),
        React.createElement(RankingBody, null)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/ranking/TabRanking.tsx
// module id = 2741
// module chunks = 3